<script setup lang="ts">
import type { OrganizationJs } from "@/generated/models";
import { SimpleDialogTitle } from "ls/components/simple-dialog";

defineProps<{
  organization: OrganizationJs;
}>();
</script>

<template>
  <div>
    <SimpleDialogTitle class="text-black">
      {{ organization?.Name }} is on the free plan
    </SimpleDialogTitle>
    <div class="mt-4">
      Free plan includes 3 whiteboards and 10 documents. Moving these items would put {{ organization?.Name }}
      over their free plan limits. Upgrade for unlimited whiteboards and documents.
    </div>
  </div>
</template>
